import React from "react";
import {Card, Image} from "react-bootstrap";
import blackLogo  from "./taugetherLogoBlack.png";

export default function About() {
    return (
        <>
            <Image src={blackLogo} style={{width: 150}}/>
            <Card className="text-md-end">
                <Card.Body>
                    <h1>אודותינו</h1>
                    <p dir="rtl" className="big">
                        Taugether (מהמילה ׳ביחד׳ באנגלית) הינו מיזם שיתופי-מהפכני מתחום התחבורה הנותן מענה לבעיה השכיחה והאקוטית ביותר במדינת ישראל - הפקקים.
                        <br/>
                        באמצעותו, יוכלו הסטודנטים להגיע, אחת ולתמיד, למוסד לימודיהם בזמן הקצר והמהיר ביותר כל זאת על ידי הצטרפות לרכבים, שכבר בדרכם למקום, ושגם תפחית משמעותית את כמות הרכבים שעל הכביש ותהווה פיתרון ירוק לאקלים ההולך ומתחמם.
                        <br/>
                        המיזם, שפותח על ידי סטודנטים וסטודנטיות מאוניברסיטת תל אביב בהנחיית יוגב שני, ייעשה שימוש תחילה עבור אלו הנמצאים במרכז, אולם בהמשך יתרחב לפריסה ארצית.
                        <br/>
                        שם המיזם מאגד בתוכו את הערך החברתי החשוב ביותר והוא together (ביחד), ובמילים אחרות הדרך היחידה שבאמצעותה נוכל להגיע ממקום למקום באופן הפשוט והנוח ביותר היא ביחד, ובינינו זה גם עדיף על להיות לבד.
                    </p>
                </Card.Body>
            </Card>
        </>
    )
}